import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import LinkButton from '@/components/link_button/Index.vue';
import ActionButton from '@/components/action_button/Index.vue';
import PageTitle from '@/components/v2/PageTitle.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { STORE_MANAGEMENT, SHOPIFY, AFFILIATE } from '@/helpers/constants/CustomBundleKeys';
let BaseSetting = class BaseSetting extends Mixins(ViewportSizeMixin, RouterParamsAppMixin) {
    /**
     * Store Manager Dashboard Checker
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.21.0}
     */
    get isStoreManager() {
        return this.bundleKey === STORE_MANAGEMENT;
    }
    get isShopify() {
        return this.bundleKey === SHOPIFY;
    }
    get isAffiliate() {
        return this.bundleKey === AFFILIATE;
    }
    tabBuilder() {
        const commonProps = {
            orangeTheme: true,
            flat: true,
            capitalized: true,
            navigator: true,
            exact: true,
        };
        if (this.isPageSubscription) {
            const commonTabs = [
                {
                    ...commonProps,
                    path: { name: 'facebook-page-subscription' },
                    id: 'fbMessenger',
                    label: 'Facebook Messenger In-App Store',
                },
            ];
            if (this.isAffiliate) {
                return commonTabs;
            }
            return [
                ...commonTabs,
                {
                    ...commonProps,
                    path: { name: 'miniprogram-subscription' },
                    id: 'miniProgram',
                    label: 'GLife store on GCash',
                },
                // {
                //   ...commonProps,
                //   path: { name: 'viber-subscription' },
                //   id: 'pageSubscription',
                //   label: 'Viber',
                // },
                {
                    ...commonProps,
                    path: { name: 'instagram-subscription' },
                    id: 'instagram',
                    label: 'Instagram',
                },
            ];
        }
        if (this.isShopify && this.isMiniAppSettings) {
            return [
                {
                    ...commonProps,
                    path: { name: 'mini-app-settings' },
                    id: 'miniAppSettings',
                    label: 'In-App Store Settings',
                },
                {
                    ...commonProps,
                    path: { name: 'shopify-settings' },
                    id: 'shopifySettings',
                    label: 'Shopify Settings',
                },
            ];
        }
        return [];
    }
    get isPageSubscription() {
        return /subscription/.test(this.$route.fullPath);
    }
    get isMiniAppSettings() {
        return /settings/.test(this.$route.fullPath);
    }
    get isRouteWhitelistedInTab() {
        return /members/.test(this.$route.fullPath);
    }
};
BaseSetting = __decorate([
    Component({
        components: {
            LinkButton,
            ActionButton,
            PageTitle,
        },
    })
], BaseSetting);
export default BaseSetting;
